import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnDM: CultureInfo = {
  name: 'en-DM',
  displayName: 'English (Dominica)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-DM',
  parent: CultureInfoEn
};
